export default function PrivacyContent() {
  return (
    <>
      <p className="text-text-muted">Last Updated: December 29, 2025</p>

      <p className="text-text-secondary">
        This Privacy Policy explains how AgileForce LTD collects, uses,
        stores, and protects personal information when you use the
        Vector Migration tool, in compliance with UK GDPR.
      </p>

      <Section title="1. Information We Collect">
        <List items={["Email address", "Password", "Device and usage data", "IP address"]} />
      </Section>

      <Section title="2. Payment Information">
        <p className="text-text-secondary">
          We do not store full card details. Payments are processed by
          third-party providers, and only transaction metadata is stored.
        </p>
      </Section>

      <Section title="3. How We Use Your Information">
        <List items={["Account creation and authentication", "Service improvement", "Security monitoring", "Legal compliance"]} />
      </Section>

      <Section title="4. Legal Basis for Processing">
        <List items={["Contract performance", "Legitimate interests", "Legal obligations"]} />
      </Section>

      <Section title="5. Data Retention">
        <p className="text-text-secondary">
          Data is retained only as necessary and deleted upon account
          removal unless legally required.
        </p>
      </Section>

      <Section title="6. Your Rights">
        <List items={["Access and correction", "Deletion", "Restriction", "Portability", "Complaint with the ICO"]} />
      </Section>

      <Section title="Contact">
        <p className="text-text-secondary">
          AgileForce LTD <br />
          Email: admin@agileforce.co.uk
        </p>
      </Section>
    </>
  );
}

/* ---------- helpers ---------- */

function Section({ title, children }) {
  return (
    <div className="space-y-2">
      <h3 className="font-semibold text-text-primary">{title}</h3>
      {children}
    </div>
  );
}

function List({ items }) {
  return (
    <ul className="list-disc list-inside space-y-1 text-text-secondary">
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}